import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import Layout from '@/components/feature/Layout';
import Home from '@/pages/home/page';
import Services from '@/pages/services/page';
import Communities from '@/pages/communities/page';
import About from '@/pages/about/page';
import Contact from '@/pages/contact/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: 'services', element: <Services /> },
      { path: 'communities', element: <Communities /> },
      { path: 'about', element: <About /> },
      { path: 'contact', element: <Contact /> },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;